<template>
	<o-sticker
		class="profile-completion-sticker no-shadow">
		<div class="flex flex--wrap no-padding">
			<div class="thumbnail">
				<img
					:src="useDynamicImg(`TempworkerDocumentOutline${setup.iconLabel}Svg`)"
					:alt="typeLabel">
				<div class="thumbnail__status-picto">
					<o-icon
						v-if="isMissing"
						font-icon="icon-interface-alert-warning-triangle"
						class="text--danger"/>
					<o-icon
						v-else
						icon="check"
						class="text--success"/>
				</div>
			</div>
			<div>
				<p class="description">{{ title }}</p>
				<small
					:class="!isMissing ? `text--success` : ``"
					class="description description--small">
					{{ setup.subTitle }}
				</small>
			</div>

			<o-button
				class="bubble-indicator bubble-indicator--right no-border right-in-card"
				outline
				:color="setup.buttonColor"
				:prefix-font-icon="setup.buttonIcon"
				@click="setup.buttonAction()"/>
		</div>
	</o-sticker>
</template>

<script setup lang="ts">
import useDynamicImg from '@/services/DynamicImg';
import DashboardTempWorkerProfileCompletionStickerSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerProfileCompletionStickerSetupService';
type Emits = { (e: 'uploaded'): void }
const emits = defineEmits<Emits>();
const props = defineProps(DashboardTempWorkerProfileCompletionStickerSetupService.props);
const setup = new DashboardTempWorkerProfileCompletionStickerSetupService(props, emits);
</script>

<style scoped lang="less">
@import '@/styles/variables';
@import '@/styles/mixins';

@thumbnailDuration: 0.6s;

.no-shadow {
	box-shadow: none;
}
.no-padding{
  padding: 0px;
}

.profile-completion-sticker {

	@media @layoutNavBottom {
		padding: 0.5rem 0;
	}

.completion__title{
  margin-top: 8px;
}

.orion-sticker__responsive {
  padding: 10px;
}

  .thumbnail, .thumbnail__mask {
    .circle(50px);
    position: relative;
    flex: 0 0 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--grey-lighter);

    img {
      width: 30px;
      max-width: none;
    }
  }

  .thumbnail {
		&__mask {
			.circle(0px);
			transition: width @thumbnailDuration * 1.5, height @thumbnailDuration * 1.5, border-radius @thumbnailDuration * 1.5;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			overflow: hidden;
		}

		&__status-picto {
			.circle(20px);
			.flex-align();
			position: absolute;
			bottom: 0;
			right: 0;
			background: white;
			font-size: 16px;
		}
  }

  .description {
		margin-left: 18px;
		margin-top: 8px;
		margin-bottom: 0px;
		font-size: 16px;
		font-weight: bold;

		&--small{
			font-size: 12px;
			font-weight: unset;
			margin-top: none;
		}

		@media @tablet {
			margin-right: 10px;
		}

		+ .orion-button {
			margin: 10px auto 0;
			@media @tablet {
				margin: auto;
			}
		}
	}

	.orion-sticker {
		&__actions {
			flex: 1 0 auto;
		}

		&__title:only-child {
			margin: 0;
		}

		&__content {
			div.flex {
				flex-wrap: wrap;
				@media @tablet {
					flex-wrap: nowrap;
				}
			}
		}
	}

  &:hover {
    .thumbnail__mask {
      transition: width @thumbnailDuration, height @thumbnailDuration, border-radius @thumbnailDuration;
      .circle(70px);
    }
	}

	.nested-doc {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		background: whitesmoke;
		padding: 10px;
		border-radius: 5px;

		@media @tablet {
			flex-wrap: nowrap;
		}

		+ .nested-doc {
			margin-top: 7px;
		}

		&__title-date {
			flex: 1;
			flex-wrap: wrap;
			max-width: calc(100% - 120px);

			@media @desktop {
				display: flex;
			}
		}

		&__title {
			.ellipsis();
			display: block;
			flex: 0 0 45%;
		}

		&__date {
			.ellipsis();
			flex: 0 0 45%;
		}

		&__actions {
			flex: 0 0 120px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 18px;
			height: 20px;

			.orion-icon {
				margin: 0 10px;
			}
		}

		&-list {
			margin-bottom: 10px;

			@media @tablet {
				padding-left: 90px;
			}
		}
	}
}
.no-border{
	border: none;
}

.orion-sticker{
	.right-in-card{
		right: 10px;
	}

}
</style>
